import { useLocation } from 'react-router-dom'
import { PasswordResetUpdatePage } from './PasswordResetUpdatePage'
import { PasswordResetEmailPage } from './PasswordResetEmailPage'

export const PasswordResetPage = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const [userId, token] = [params.get('user_id'), params.get('token')]

  if (userId && token) {
    return PasswordResetUpdatePage({ userId, token })
  } else {
    return PasswordResetEmailPage()
  }
}
